module.exports = __webpack_public_path__ + "static/media/down-arrow.692f7a00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/down-arrow.svg
// module id = 294
// module chunks = 0